import { config } from "@/services/config";
import { NearRPCProviderService } from "@/services/rpc/near";

class TotalScoreContract {
  readonly contractId: string;

  private provider: NearRPCProviderService;

  public constructor({ provider, contractId }: { provider: NearRPCProviderService; contractId: string }) {
    this.contractId = contractId;
    this.provider = provider;
  }

  public async get_user(tgId: string): Promise<{
    user_id: string;
    score: number;
    tg_id: number;
  }> {
    // @ts-expect-error: re-using view function needed
    return this.provider.viewFunction("get_user", this.contractId, { tg_id: tgId }) as unknown as {
      user_id: string;
      score: number;
      tg_id: number;
    };
  }

  public async get_mint_data() {
    return this.provider.viewFunction("get_metadata", this.contractId, {});
  }
}

export const NearTotalScoreContract = new TotalScoreContract({
  provider: new NearRPCProviderService(),
  contractId: config.near.totalScoreContract,
});
